var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M2.5 1.5H13.5V14.5H2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M13,2v12H3V2H13 M14,1H2v14h12V1L14,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#735f63",
    d: "M4.5 3.5H11.5V14.5H4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d3e40",
    d: "M11,4v10H5V4H11 M12,3H4v12h8V3L12,3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f4144",
    d: "M7 4H9V14H7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4a281",
    d: "M7 2H9V3H7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M4.939 15.5L2.5 14.646 2.5 1.354 4.939 0.5 6.5 0.5 6.5 15.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M6,1v14H5.024L3,14.291V1.709L5.024,1H6 M7,0H4.854L2,1v14l2.854,1H7V0L7,0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd7bd",
    d: "M5 1H6V15H5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M4.5 8A0.5 0.5 0 1 0 4.5 9A0.5 0.5 0 1 0 4.5 8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door--open.82b18fbd4e3cc2dda4cae4b87cbbecfa.svg";
export { ForwardRef as ReactComponent };